import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import blogs from "../../api/blogs";

import shapeLeft from "../../images/shape/prev-shape.png";
import shapeRight from "../../images/shape/next-shape.png";

const BlogSlider: React.FC = () => {
  const topSlides = blogs.slice(0, 4);

  return (
    <section className="blog pt-70">
      <div className="container">
        <div className="blog-slider pos-rel">
          <Swiper
            modules={[Navigation, Pagination]}
            slidesPerView={1}
            spaceBetween={30}
            loop={true}
            pagination={{ clickable: true }}
            navigation={{
              nextEl: ".blog-swiper-btn.swiper-button-next",
              prevEl: ".blog-swiper-btn.swiper-button-prev",
            }}
            className="swiper-container"
          >
            {topSlides.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="blog-slide-item">
                  <div className="xb-item--img">
                    <img src={item.image} alt={item.title} />
                  </div>

                  <div className="xb-item--holder">
                    <Link
                      to={`/blog/${item.slug}`}
                      className="xb-item--tag xb-border"
                    >
                      # {item.tag}
                    </Link>

                    <h2 className="xb-item--title">
                      <Link to={`/blog/${item.slug}`}>{item.title}</Link>
                    </h2>

                    <p className="xb-item--content">{item.excerpt}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* PAGINATION */}
          <div className="swiper-pagination"></div>

          {/* NAV BUTTONS */}
          <div className="blog-item_button">
            <div className="blog-swiper-btn swiper-button-prev">
              <img src={shapeLeft} alt="" />
              <i className="fa-regular fa-angles-left"></i>
            </div>

            <div className="blog-swiper-btn swiper-button-next">
              <img src={shapeRight} alt="" />
              <i className="fa-regular fa-angles-right"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSlider;
